// 部署
export const BusyoCd = Object.freeze({
  SALES: 1, // 営業
  GENBA: 2, // 工事部
});

export const BusyoCds = Object.freeze([
  {
    key: BusyoCd.SALES,
    value: '営業部',
  },
  {
    key: BusyoCd.GENBA,
    value: '工事部',
  }
]);

// 顧客区分
export const ClientType = Object.freeze({
  USER: 1, // 個人
  CORP: 2, // 法人
  PUBLIC: 3, // 公共
});

export const ClientTypes = Object.freeze([
  {
    key: ClientType.USER,
    value: '個人',
  },
  {
    key: ClientType.CORP,
    value: '法人',
  },
  {
    key: ClientType.PUBLIC,
    value: '公共',
  },
]);

// 案件区分
export const ProjectType = Object.freeze({
  NEW: 1, // 新規
  REPEAT: 2, // リピート
});

// 案件区分
export const ProjectTypes = Object.freeze([
  {
    key: '',
    value: '　',
  },
  {
    key: ProjectType.NEW,
    value: '新規',
  },
  {
    key: ProjectType.REPEAT,
    value: 'リピート',
  },
]);

// 工事区分１
export const KoujiKbn1 = Object.freeze([
  {
    key: '',
    value: '　',
  },
  {
    key: 1,
    value: '造園',
  },
  {
    key: 2,
    value: '建築',
  },
  {
    key: 3,
    value: '管理',
  },
]);

// 工事区分２
export const KoujiKbn2Type = Object.freeze({
  NEW: 1, // 新築
  REFORM: 2, // リフォーム
  MINOR_CONSTRUCTION: 3, // 小工事
  SPOT: 4, // スポット
  ANNUAL: 5, // 年間
});
// 工事区分２
export const KoujiKbn2 = Object.freeze([
  {
    key: '',
    value: '　',
    KoujiKbn1: [0, 1, 2, 3],
  },
  {
    key: KoujiKbn2Type.NEW,
    value: '新築',
    KoujiKbn1: [1, 2],
  },
  {
    key: KoujiKbn2Type.REFORM,
    value: 'リフォーム',
    KoujiKbn1: [1, 2],
  },
  {
    key: KoujiKbn2Type.MINOR_CONSTRUCTION,
    value: '小工事',
    KoujiKbn1: [1, 2],
  },
  {
    key: KoujiKbn2Type.SPOT,
    value: 'スポット',
    KoujiKbn1: [3],
  },
  {
    key: KoujiKbn2Type.ANNUAL,
    value: '年間',
    KoujiKbn1: [3],
  },
]);

// 来店きっかけ区分
export const VisitType = Object.freeze({
  NORMAL: 1, // 通常
  CORP: 2, // コープ
  KENCHO: 3, // 県庁生協
});

// 来店きっかけ
export const VisitReason = Object.freeze([
  {
    key: 0,
    value: '　',
  },
  {
    key: 1,
    value: 'ご紹介',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 2,
    value: '新聞・DM',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 3,
    value: 'ご近所',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 4,
    value: '園芸売店',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 5,
    value: 'SNS',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 6,
    value: 'ホームページ',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 7,
    value: '庭チャンネル',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 8,
    value: 'コープ（新規）',
    type: ProjectType.NEW,
    VisitType: VisitType.CORP,
  },
  {
    key: 9,
    value: '県庁生協（新規）',
    type: ProjectType.NEW,
    VisitType: VisitType.KENCHO,
  },
  {
    key: 10,
    value: '公共（新規）',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 11,
    value: '知っていた',
    type: ProjectType.NEW,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 1000,
    value: '個人（リピート）',
    type: ProjectType.REPEAT,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 1001,
    value: '法人（リピート）',
    type: ProjectType.REPEAT,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 1002,
    value: 'コープ（リピート）',
    type: ProjectType.REPEAT,
    isCoopOrKencho: true,
    VisitType: VisitType.CORP,
  },
  {
    key: 1003,
    value: '県庁生協（リピート）',
    type: ProjectType.REPEAT,
    isCoopOrKencho: true,
    VisitType: VisitType.KENCHO,
  },
  {
    key: 1004,
    value: '公共（リピート）',
    type: ProjectType.REPEAT,
    VisitType: VisitType.NORMAL,
  },
  {
    key: 1005,
    value: 'はるな墓苑',
    type: ProjectType.REPEAT,
    VisitType: VisitType.NORMAL,
  },
]);

// エリア
export const Areas = Object.freeze([
  {
    key: '',
    value: '　',
  },
  {
    key: 1,
    value: '旧高崎市内・新町',
    important: true,
  },
  {
    key: 2,
    value: '高崎市北部',
    important: true,
  },
  {
    key: 3,
    value: '伊勢崎市・玉村町',
    important: true,
  },
  {
    key: 4,
    value: '前橋市',
    important: true,
  },
  {
    key: 5,
    value: '藤岡市',
    important: true,
  },
  {
    key: 6,
    value: '安中市・富岡市',
    important: false,
  },
  {
    key: 7,
    value: '吉井町・甘楽町',
    important: true,
  },
  {
    key: 8,
    value: '東毛地区',
    important: false,
  },
  {
    key: 9,
    value: '北毛地区',
    important: false,
  },
  {
    key: 10,
    value: '埼玉県北部',
    important: true,
  },
  {
    key: 99,
    value: 'その他',
    important: false,
  },
]);

// 工事費用タイプ
export const KoujiHiyou = Object.freeze([
  {
    key: 1,
    value: '通常',
  },
  {
    key: 2,
    value: '運搬等諸経費',
  },
  {
    key: 3,
    value: '工事費の1～3%',
  },
]);

// 工事費パーセンテージ
export const KoujihiPersent = [
  { id: 0, KOUJI_TYPE: 0, name: '' },
  { id: 10, KOUJI_TYPE: 2, name: '10%' },
  { id: 11, KOUJI_TYPE: 2, name: '11%' },
  { id: 12, KOUJI_TYPE: 2, name: '12%' },
  { id: 13, KOUJI_TYPE: 2, name: '13%' },
  { id: 14, KOUJI_TYPE: 2, name: '14%' },
  { id: 15, KOUJI_TYPE: 2, name: '15%' },
  { id: 16, KOUJI_TYPE: 2, name: '16%' },
  { id: 17, KOUJI_TYPE: 2, name: '17%' },
  { id: 18, KOUJI_TYPE: 2, name: '18%' },
  { id: 19, KOUJI_TYPE: 2, name: '19%' },
  { id: 20, KOUJI_TYPE: 2, name: '20%' },
  { id: 101, KOUJI_TYPE: 2, name: '手入力' },
  { id: 1, KOUJI_TYPE: 3, name: '1%' },
  { id: 2, KOUJI_TYPE: 3, name: '2%' },
  { id: 3, KOUJI_TYPE: 3, name: '3%' },
  { id: 102, KOUJI_TYPE: 3, name: '手入力' },
];

// 年代（定数）
export const AgeCategory = Object.freeze({
  AGE_20: 1, // 20～30代
  AGE_40: 2, // 40-50代
  AGE_60: 3, // 60代以上
  AGE_CORP: 101, // 法人
  AGE_PUBLIC: 102, // 公共
});

// 年代
export const AgeCategories = Object.freeze([
  {
    key: 0,
    value: '不明',
  },
  {
    key: AgeCategory.AGE_20,
    value: '20～30代',
  },
  {
    key: AgeCategory.AGE_40,
    value: '40～50代',
  },
  {
    key: AgeCategory.AGE_60,
    value: '60代以上',
  },
]);

// 年代
export const AgeCategoryWithClientTypes = Object.freeze([
  ...AgeCategories,
  {
    key: AgeCategory.AGE_CORP,
    value: '法人',
  },
  {
    key: AgeCategory.AGE_PUBLIC,
    value: '公共',
  },
]);

// DM要否
export const DmKbn = Object.freeze([
  {
    key: 0,
    value: '',
  },
  {
    key: 1,
    value: '自宅',
  },
  {
    key: 2,
    value: '請求先',
  },
  {
    key: 3,
    value: '送付しない',
  },
]);

// 電話番号の続柄
export const TelRelation = Object.freeze([
  {
    key: 0,
    value: '　',
  },
  {
    key: 1,
    value: '自宅',
  },
  {
    key: 2,
    value: '施主携帯',
  },
  {
    key: 3,
    value: 'ご主人携帯',
  },
  {
    key: 4,
    value: '奥様携帯',
  },
  {
    key: 5,
    value: '子供携帯',
  },
  {
    key: 6,
    value: '実家',
  },
  {
    key: 7,
    value: '父携帯',
  },
  {
    key: 8,
    value: '母携帯',
  },
  {
    key: 9,
    value: '会社',
  },
]);
// 見積書フォーマット区分
export const QuoteFormatType = Object.freeze({
  WIDE: 1, // 見積書横
  VERTICAL: 2, // 見積書縦
});

// 見積書フォーマット区分
export const QuoteFormatTypes = Object.freeze([
  {
    key: QuoteFormatType.WIDE,
    value: '見積書横',
  },
  {
    key: QuoteFormatType.VERTICAL,
    value: '見積書縦',
  },
]);

// アフター返信備考
export const CardReturnBiko = Object.freeze([
  {
    key: 0,
    value: '　',
  },
  {
    key: 1,
    value: 'TEL',
  },
  {
    key: 2,
    value: '直接',
  },
  {
    key: 3,
    value: '返信なし',
  },
]);